export default {"src":"/_next/static/media/BlossmLogoLarge.675dc663.svg","height":72,"width":332,"blurWidth":0,"blurHeight":0};